(function ($) {

'use strict';

	/**
	 * load a video file from slider
	 * @param {bool} startPlay
	 */
	$.fn.loadVideo = function (startPlay, config) {
		if ($(this).length < 1) {
			return;
		}

		var options = $.extend({
			videoSelector: '.video-slider-container video'
		}, (config || {}));
		
		

		var player = $(options.videoSelector)[0];
		var $img = $(this).find('img');
		var $imgsrc = $img.attr('src');

		// checking if selected video equals the active one
		if (player &&
				($imgsrc !== $(options.videoSelector).attr('poster') || player.paused || options.videoID !== $(options.videoSelector).attr('data-idx'))) {
			$(options.videoSelector).attr('data-idx', options.videoID);
			
			$('.imglink').removeClass('active');
			$(this).find('.imglink').addClass('active');

			player.pause();
			var $mp4src = ($img.attr('data-src') || $imgsrc.substring(0, $imgsrc.lastIndexOf('.')) + '.mp4');
//			var $oggsrc = $imgsrc.substring(0, $imgsrc.lastIndexOf('.')) + '.ogv';

			var vTitle = '';
			var $title = $(this).find('figcaption');
			if ($title.length > 0) {
				vTitle = $title.html();
			} else {
				$(this).first().children('p').each(function () {
					vTitle += '<p>' + $(this).html() + '</p>';
				});
			}
			$('.video-player-container').find('.vtitle').not('.gtitle').html(vTitle);

			$(options.videoSelector).attr('poster', $imgsrc);
			$('source[type="video/mp4"]').attr('src', $mp4src);
//			$('source[type="video/ogg"]').attr('src', $oggsrc);
			player.load();
			if (startPlay === true) {
				player.play();
			}
		}
	}; // $.fn.loadVideo

}(jQuery));